import axios from "axios";
import { h, Component } from "preact";
import { useContext } from "preact/hooks";

import {Config} from "../Store";
import { getFeedEndpoints } from "../utils";
import AlertSection from "./AlertSection";

import styles from "./styles.scss";

export default class Widget extends Component {
    constructor() {
        super();
        this.state = {
            alerts: [],
            error: false,
            loading: true
        };
    }

    componentDidMount() {
        // load and filter alerts data
        let { alertFeeds } = this.props;
        let feedURLs = getFeedEndpoints(alertFeeds);
        axios.all(feedURLs.map(url => axios.get(url)))
          .then(axios.spread((...results) => {
              let combinedAlerts = results.map(res => {
                // for now, if one of the feeds returns without data, silently ignore
                // TODO: add more informative error handling
                if (res.data) {
                  return res.data;
                } else {
                    return [];
                }
              }).reduce((acc, val) => acc.concat(val), []);
              let filteredAlerts = this.filterAlerts(combinedAlerts);
              this.setState({ alerts: filteredAlerts, loading: false });
          }));
    }

    // TODO: Provide filtering by route/agency
    filterAlerts(alerts) {
      return alerts;
    }

    renderAlerts() {
        return (
            <AlertSection
                alerts={this.state.alerts}
            />
        );
    }

    renderError() {
        return (
            <div>Error: Could not load service alerts.</div>
        );
    }

    renderLoading() {
        return (
            <div>Loading alerts...</div>
        );
    }

    renderEmpty() {
        let { hideIfNoAlerts } = useContext(Config);
        if (hideIfNoAlerts) {
            return <div></div>;
        }
        return (
            <div class={styles.infoBanner}>
                There are no service alerts at this time.
            </div>
        );
    }

    renderContent() {
        if (this.state.loading) {
            return this.renderLoading();
        }
        if (this.state.error) {
            return this.renderError();
        }
        if ( this.state.alerts.length === 0) {
            return this.renderEmpty();
        }
        return this.renderAlerts();
    }

    render() {
        return (
            <div class={styles.widget}>
                {this.props.widgetTitle && <h2>{this.props.widgetTitle}</h2>}
                {this.renderContent()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/Widget.js